import { Link } from "react-router-dom";

export default function SectionHeading({
  eyebrow,
  title,
  description,
  action,
  align = "left",
}: {
  eyebrow?: string;
  title: string;
  description?: string;
  action?: { label: string; to: string };
  align?: "left" | "center";
}) {
  const isCenter = align === "center";

  return (
    <div
      className={`flex flex-col gap-4 md:flex-row md:items-end md:justify-between ${
        isCenter ? "text-center md:flex-col md:items-center md:justify-center" : ""
      }`}
    >
      <div className={isCenter ? "max-w-2xl mx-auto" : "max-w-2xl"}>
        {eyebrow && (
          <p className="flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-primary-600 uppercase justify-center md:justify-start">
            <span className={`w-6 h-px bg-primary-500 ${isCenter ? "hidden md:block" : ""}`}></span>
            {eyebrow}
          </p>
        )}
        <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950 tracking-tight">
          {title}
        </h2>
        {description && (
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
            {description}
          </p>
        )}
      </div>
      {action && !isCenter && (
        <Link
          to={action.to}
          className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap shrink-0"
        >
          {action.label}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}